import React from "react";
import { ICellRendererParams } from "@ag-grid-community/core";

import { GridInventoryAdjustment } from "../../../types/inventoryAdjustments";
import AssigneeInventoryAdjustmentSelect from "../../AssigneeInventoryAdjustmentSelect";

interface Props extends ICellRendererParams {
  canAssign?: boolean;
  data: GridInventoryAdjustment;
}

const AssigneeRenderer = ({ canAssign, data }: Props) => {
  return (
    <AssigneeInventoryAdjustmentSelect
      canAssign={canAssign}
      assigneeId={data.assigneeId}
      assigneeName={data.assigneeDisplayName}
      inventoryAdjustment={data}
    />
  );
};

export default AssigneeRenderer;
